export default import.meta.ROLLUP_FILE_URL_7AbVtktR6Pt0SdugWKgNEw